import React, { ReactElement } from 'react';
import { Box, Typography, Card, CardContent, CardActions, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function AdminDashboard(): ReactElement {
    const navigate = useNavigate();

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            <Typography variant="h4" gutterBottom>
                Admin Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Monitor and manage your Planning Poker application
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                <Card sx={{ minWidth: 300, flex: '1 1 300px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            User Management
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            View and manage users, their plans, and activity
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button 
                            size="small" 
                            onClick={() => navigate('/admin/users')}
                        >
                            Manage Users
                        </Button>
                    </CardActions>
                </Card>

                <Card sx={{ minWidth: 300, flex: '1 1 300px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Analytics
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            View usage analytics and insights
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button 
                            size="small" 
                            onClick={() => navigate('/admin/analytics')}
                        >
                            View Analytics
                        </Button>
                    </CardActions>
                </Card>

                <Card sx={{ minWidth: 300, flex: '1 1 300px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            User Feedback
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            View and manage user feedback and trial extension requests
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button 
                            size="small" 
                            onClick={() => navigate('/admin/feedback')}
                        >
                            View Feedback
                        </Button>
                    </CardActions>
                </Card>

                <Card sx={{ minWidth: 300, flex: '1 1 300px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Settings
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Configure admin settings and preferences
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button 
                            size="small" 
                            onClick={() => navigate('/admin/settings')}
                        >
                            Settings
                        </Button>
                    </CardActions>
                </Card>
            </Box>
        </Container>
    );
}
